// extracted by mini-css-extract-plugin
module.exports = {"imprint":"About_imprint__9qF-z","aboutContent":"About_aboutContent__z7xo6"};